import { useState, useEffect } from 'react';
import { X, Share, PlusSquare } from 'lucide-react';

const DISMISS_KEY = 'ios-install-banner-dismissed';
const DISMISS_DURATION_MS = 14 * 24 * 60 * 60 * 1000; // 14 days

const IOSInstallBanner = () => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const ua = navigator.userAgent || '';

        // Only show on iOS Safari (iPhone/iPad)
        const isIOS = /iPad|iPhone|iPod/.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
        if (!isIOS) return;

        // Don't show if already running as standalone PWA
        const isStandalone = window.matchMedia('(display-mode: standalone)').matches
            || window.navigator.standalone === true;
        if (isStandalone) return;

        // Don't show if running in a WebView (e.g., in-app browser)
        const isWebView = /CriOS|FxiOS|OPiOS|EdgiOS/i.test(ua);
        if (isWebView) return;

        // Check dismiss state
        const dismissedAt = localStorage.getItem(DISMISS_KEY);
        if (dismissedAt && Date.now() - Number(dismissedAt) < DISMISS_DURATION_MS) return;

        // Small delay so page loads first
        const timer = setTimeout(() => setVisible(true), 2000);
        return () => clearTimeout(timer);
    }, []);

    const dismiss = () => {
        setVisible(false);
        localStorage.setItem(DISMISS_KEY, String(Date.now()));
    };

    if (!visible) return null;

    return (
        <div
            data-testid="ios-install-banner"
            className="mx-3 mt-3 mb-1 rounded-2xl overflow-hidden"
            style={{ background: 'linear-gradient(135deg, #1a2e1a 0%, #0f172a 100%)' }}
        >
            <div className="flex items-start gap-3 px-4 py-3">
                <div className="w-10 h-10 rounded-xl bg-emerald-500/20 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <PlusSquare className="w-5 h-5 text-emerald-400" />
                </div>
                <div className="flex-1 min-w-0">
                    <p className="text-white text-sm font-semibold leading-tight">Install BrainSync</p>
                    <p className="text-white/50 text-xs mt-1 leading-relaxed">
                        Tap <Share className="w-3 h-3 inline-block mx-0.5 -mt-0.5" /> then <span className="font-medium text-white/70">"Add to Home Screen"</span>
                    </p>
                </div>
                <button
                    onClick={dismiss}
                    data-testid="ios-install-banner-dismiss"
                    className="flex-shrink-0 text-white/30 hover:text-white/70 transition-colors p-0.5"
                >
                    <X className="w-4 h-4" />
                </button>
            </div>
        </div>
    );
};

export default IOSInstallBanner;
